import {
  ActionIcon,
  Box,
  Group,
  Paper,
  Text,
  TextInput,
  Button,
} from "@mantine/core";
import React, { useEffect } from "react";
import { X } from "tabler-icons-react";

function LettreManquanteForm({ form, index }) {
  const correction_dp = form.values.epreuves[index]?.correction_dp || "";
  const choices = form.values.epreuves[index]?.choices || [];

  useEffect(() => {
    if (correction_dp && !choices.length) {
      // Initialize choices as empty array
      form.setFieldValue(`epreuves.${index}.choices`, []);
    }
  }, [correction_dp]);

  const handleLetterClick = (letter) => {
    const currentChoices = form.values.epreuves[index]?.choices || [];
    if (!currentChoices.includes(letter)) {
      form.setFieldValue(`epreuves.${index}.choices`, [...currentChoices, letter]);
    }
  };

  const handleRemoveChoice = (letter) => {
    const currentChoices = form.values.epreuves[index]?.choices || [];
    form.setFieldValue(
      `epreuves.${index}.choices`,
      currentChoices.filter((l) => l !== letter)
    );
  };

  return (
    <Paper mb={20} p={10} shadow="xs">
      <Group noWrap position="apart">
        <Box style={{ flex: 1 }}>
          <TextInput
            label="Titre"
            placeholder="Mettre le titre de l'epreuve"
            {...form.getInputProps(`epreuves.${index}.titre`)}
            mb={10}
          />

          <TextInput
            label="Lettres de l'alphabet"
            placeholder="Entrez les lettres (ex: A-B-C-D-E-F)"
            {...form.getInputProps(`epreuves.${index}.correction_dp`)}
            mb={10}
          />

          {correction_dp && (
            <Group spacing={5}>
              {correction_dp.split("-").filter((letter) => !choices.includes(letter)).map((letter, letterIndex) => (
                <Button
                  key={letterIndex}
                  variant="outline"
                  size="xs"
                  style={{ width: '40px', padding: 0 }}
                  onClick={() => handleLetterClick(letter)}
                >
                  {letter}
                </Button>
              ))}
            </Group>
          )}

          {choices.length > 0 && (
            <Group spacing={5} mt={10}>
              {choices.map((letter, idx) => (
                <Box key={idx} style={{ display: 'flex', alignItems: 'center' }}>
                  <TextInput
                    value={letter}
                    readOnly
                    style={{ width: '40px', marginRight: 4 }}
                  />
                  <ActionIcon color="red" size="xs" onClick={() => handleRemoveChoice(letter)}>
                    <X size="1rem" />
                  </ActionIcon>
                </Box>
              ))}
            </Group>
          )}
        </Box>
        <ActionIcon
          color="red"
          onClick={() => form.removeListItem('epreuves', index)}
        >
          <X size="1rem" />
        </ActionIcon>
      </Group>
    </Paper>
  );
}

export default LettreManquanteForm;
